(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common/http"), require("rxjs/add/operator/map"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common/http", "rxjs/add/operator/map"], factory);
	else if(typeof exports === 'object')
		exports["ticktock"] = factory(require("@angular/core"), require("@angular/common/http"), require("rxjs/add/operator/map"));
	else
		root["ticktock"] = factory(root["ng"]["core"], root["ng"]["commonHttp"], root["Rx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var relationship_1 = __webpack_require__(2);
var models_1 = __webpack_require__(3);
var ModelFactory = (function () {
    function ModelFactory() {
    }
    ModelFactory.make = function (model, data) {
        return new model().deserialize(data);
    };
    ModelFactory.makeFromArray = function (model, array) {
        var models = [];
        for (var ii = 0; ii < array.length; ++ii) {
            models.push(new model().deserialize(array[ii]));
        }
        return models;
    };
    ModelFactory.makeRelated = function (model, related, key) {
        var relationshipConfig = model.getRelationship(key);
        var relationship = new relationship_1.Relationship(model, related, relationshipConfig.type);
        model[key] = relationship.create();
        model.setUri(model[key].getSelfUri() + '/' + model.getUri());
        return model;
    };
    ModelFactory.makeRelatedFromRelationship = function (relationship, input) {
        if (relationship.type == 'hasOne' || relationship.type == 'belongsTo') {
            return relationship.create().deserialize(input);
        }
        else if (relationship.type == 'hasMany') {
            var related = relationship.getRelated();
            var constructor = models_1.Models.get(related.key);
            return ModelFactory.makeFromArray(constructor, input);
        }
    };
    return ModelFactory;
}());
exports.ModelFactory = ModelFactory;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var base_model_1 = __webpack_require__(5);
var Relationship = (function () {
    function Relationship(model, related, type) {
        this.model = model;
        this.related = related;
        this.type = type;
    }
    Relationship.prototype.setRelated = function (related) {
        this.related = related;
    };
    Relationship.prototype.getRelated = function () {
        return this.related;
    };
    Relationship.prototype.setModel = function (model) {
        this.model = model;
    };
    Relationship.prototype.create = function () {
        // if the related model isn't instantiated,
        // instantiate it here
        if (!(this.related instanceof base_model_1.BaseModel)) {
            this.related = new this.related();
        }
        if (this.type == 'hasMany' || this.type == 'hasOne') {
            this.related.setUri(this.model.getSelfUri() + '/' + this.related.getUri());
            return this.related;
        }
        if (this.type == 'belongsTo') {
            return this.related;
        }
    };
    Relationship.prototype.getModel = function () {
    };
    Relationship.prototype.getUri = function () {
    };
    return Relationship;
}());
exports.Relationship = Relationship;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Models = (function () {
    function Models() {
    }
    Models.add = function (model) {
        var modelName = new model().constructor.name.toLowerCase();
        if (!Models.models[modelName]) {
            Models.models[modelName] = model;
        }
    };
    Models.get = function (model) {
        return Models.models[model];
    };
    Models.models = {};
    return Models;
}());
exports.Models = Models;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(5));
__export(__webpack_require__(2));
__export(__webpack_require__(3));
__export(__webpack_require__(1));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var model_factory_1 = __webpack_require__(1);
var relationship_1 = __webpack_require__(2);
var models_1 = __webpack_require__(3);
var BaseModel = (function () {
    function BaseModel() {
        this.modelConfig = {
            key: '',
            uri: '',
            hidden: [],
            relationships: {}
        };
    }
    BaseModel.prototype.setConfig = function (config) {
        this.modelConfig = __assign({}, this.getConfig(), config);
    };
    BaseModel.prototype.getConfig = function () {
        return this.modelConfig;
    };
    BaseModel.prototype.getUri = function () {
        return this.modelConfig.uri;
    };
    BaseModel.prototype.getSelfUri = function () {
        return this.modelConfig.uri + '/' + this[this.modelConfig.key];
    };
    BaseModel.prototype.setUri = function (uri) {
        this.modelConfig.uri = uri;
    };
    BaseModel.prototype.getKey = function () {
        return this.modelConfig.key;
    };
    BaseModel.prototype.getRelationship = function (key) {
        return this.modelConfig.relationships[key];
    };
    BaseModel.prototype.deserialize = function (input) {
        var config = this.getConfig();
        var relationships = [];
        for (var prop in input) {
            if (!input.hasOwnProperty(prop)) {
                continue;
            }
            if (config.hidden.indexOf(prop) > -1) {
                continue;
            }
            if (typeof input[prop] === 'object') {
                if (config.relationships.hasOwnProperty(this.snakeToCamel(prop))) {
                    relationships.push({
                        key: this.snakeToCamel(prop),
                        value: (input[prop] ? input[prop].data : null)
                    });
                }
                continue;
            }
            this[this.snakeToCamel(prop)] = input[prop];
        }
        for (var _i = 0, relationships_1 = relationships; _i < relationships_1.length; _i++) {
            var relationship = relationships_1[_i];
            if (relationship.value === null) {
                continue;
            }
            var relationshipConfig = config.relationships[relationship.key];
            var related = models_1.Models.get(relationshipConfig.model);
            var relationshipObject = new relationship_1.Relationship(this, related, relationshipConfig.type);
            this[relationship.key] = model_factory_1.ModelFactory.makeRelatedFromRelationship(relationshipObject, relationship.value);
        }
        return this;
    };
    BaseModel.prototype.snakeToCamel = function (string) {
        return string.replace(/_\w/g, function (m) {
            return m[1].toUpperCase();
        });
    };
    return BaseModel;
}());
exports.BaseModel = BaseModel;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(7));
__export(__webpack_require__(11));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(8);
var constants_1 = __webpack_require__(9);
var ApiService = (function () {
    function ApiService(http, config) {
        this.http = http;
        var root = config.api_root;
        this.setBaseUrl(root);
        this.setApiRoot(root);
    }
    ApiService.prototype.setBaseUrl = function (url) {
        this.baseUrl = url;
    };
    ApiService.prototype.getBaseUrl = function () {
        return this.baseUrl;
    };
    ApiService.prototype.setApiRoot = function (url) {
        this.apiRoot = url;
    };
    ApiService.prototype.getaApiRoot = function () {
        return this.apiRoot;
    };
    ApiService.prototype.getUrl = function (uri) {
        return this.baseUrl + '/' + uri;
    };
    ApiService.prototype.get = function (uri, options) {
        if (options === void 0) { options = {}; }
        if (options != {}) {
            return this.http.get(this.getUrl(uri), options);
        }
        return this.http.get(this.getUrl(uri));
    };
    ApiService.prototype.post = function (uri, payload) {
        return this.http.post(this.getUrl(uri), payload);
        // return this.makeRequest(uri, 'POST', body, options);
    };
    ApiService.prototype.put = function (uri, payload) {
        return this.http.put(this.getUrl(uri), payload);
        // return this.makeRequest(uri, 'PUT', body, options);
    };
    ApiService.prototype.delete = function (uri, options) {
        if (options === void 0) { options = {}; }
        return this.http.delete(this.getUrl(uri));
        // return this.makeRequest(uri, 'DELETE', null, options);
    };
    ApiService = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Inject(constants_1.CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ApiService);
    return ApiService;
}());
exports.ApiService = ApiService;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
exports.CONFIG = new core_1.InjectionToken('config');


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(4));
__export(__webpack_require__(6));
__export(__webpack_require__(13));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(8);
var api_service_1 = __webpack_require__(7);
var model_factory_1 = __webpack_require__(1);
var models_1 = __webpack_require__(4);
__webpack_require__(12);
var BackendService = (function () {
    function BackendService(api) {
        this.api = api;
    }
    // set model
    BackendService.prototype.setModel = function (model) {
        this.model = model;
    };
    BackendService.prototype.find = function (id) {
        var _this = this;
        return this.api.get(new this.model().getUri() + '/' + id).map(function (client) {
            client.data = model_factory_1.ModelFactory.make(models_1.Models.get(_this.model.key), client.data);
            return client;
        });
    };
    BackendService.prototype.save = function (data) {
        if (data[data.getKey()]) {
            return this.update(data);
        }
        return this.createNew(data);
    };
    BackendService.prototype.update = function (data) {
        var payload = data.serialize();
        return this.api.put(data.getUri() + '/' + data[data.getKey()], payload);
    };
    BackendService.prototype.createNew = function (data) {
        var payload = data.serialize();
        return this.api.post(data.getUri(), payload);
    };
    BackendService.prototype.destroy = function (data) {
        return this.api.delete(data.getUri() + '/' + data[data.getKey()]);
    };
    BackendService.prototype.get = function (model, options) {
        var _this = this;
        if (model === void 0) { model = null; }
        if (options === void 0) { options = { page: 1 }; }
        var requestOptions = {
            params: new http_1.HttpParams()
        };
        if (options.page != 1) {
            requestOptions.params = new http_1.HttpParams().set('page', String(options.page));
        }
        var observable;
        if (model === null) {
            observable = this.api.get(new this.model().getUri(), requestOptions);
        }
        else {
            observable = this.api.get(model.getUri(), requestOptions);
        }
        observable = observable.map(function (response) {
            var data = response.data;
            response.data = model_factory_1.ModelFactory.makeFromArray(models_1.Models.get(_this.model.key), data);
            return response;
        });
        return observable;
    };
    BackendService.prototype.getRelated = function (related, key, model, options) {
        if (model === void 0) { model = null; }
        if (options === void 0) { options = {}; }
        if (model == null) {
            model = this.model;
        }
        var constructor = models_1.Models.get(model.key);
        model = model_factory_1.ModelFactory.makeRelated(new constructor(), related, key);
        return this.get(model);
    };
    BackendService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [api_service_1.ApiService])
    ], BackendService);
    return BackendService;
}());
exports.BackendService = BackendService;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(6);
var constants_1 = __webpack_require__(9);
var ModelModule = (function () {
    function ModelModule() {
    }
    ModelModule_1 = ModelModule;
    ModelModule.forRoot = function (config) {
        return {
            ngModule: ModelModule_1,
            providers: [{ provide: constants_1.CONFIG, useValue: config }]
        };
    };
    ModelModule = ModelModule_1 = __decorate([
        core_1.NgModule({
            providers: [
                http_1.ApiService,
                http_1.BackendService
            ],
            declarations: [],
            exports: []
        })
    ], ModelModule);
    return ModelModule;
    var ModelModule_1;
}());
exports.ModelModule = ModelModule;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.umd.min.js